import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ReferenceLibraryService } from 'reference-library';
import { SettingsApiService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-change-language',
  templateUrl: './change-language.component.html',
  styleUrls: ['./change-language.component.scss']
})
export class ChangeLanguageComponent implements OnInit {
  languageList = [];
  selectedLang = {
    name: 'English',
    code: 'en'
  };
  constructor(private settingsApiService: SettingsApiService,
      private referenceLibraryService: ReferenceLibraryService,
      private toastr: ToastrService,) { }

  ngOnInit(): void {
    this.getLanguageList();
  }

  getCurrentLanguage() {
    const beneficiaryId = sessionStorage.getItem('beneficiaryId');
    this.settingsApiService.getCurrentLanguage(beneficiaryId).subscribe(
      (val: any) => {
        this.selectedLang = this.languageList?.find(item => item.code == val.data);
        this.translet();
      }
    )
  }

  getLanguageList() {
    this.settingsApiService.getLanguagesList().subscribe((response: any) => {
      this.languageList = response?.data;
      this.getCurrentLanguage();
    });
  }

  handlerLanguageChange(e: any) {
    //sessionStorage.removeItem("currentLanguage");
    this.selectedLang = e;
    //sessionStorage.setItem("currentLanguage", e.code);
    //sessionStorage.removeItem('transletedLabel');
    //this.translet();
  }

  handlerPostLanguageChangeSaved() {
    sessionStorage.removeItem("currentLanguage");
    sessionStorage.setItem("currentLanguage", this.selectedLang.code);
    this.translet();
  }

  translet() {
    setTimeout(() => {
      this.referenceLibraryService.transletConversion();
    }, 600);
  }
  
  saveChangeLanguage() {
    const beneficiaryId = sessionStorage.getItem('beneficiaryId');
    const preferredLanguage = this.selectedLang.code;
    this.settingsApiService.changeLanguage(beneficiaryId, preferredLanguage).subscribe(
      (val: any) => {
        this.handlerPostLanguageChangeSaved();
        this.toastr.success(val.message)
      }
    )
  }

}
